import axiosInstance from '../../api/axiosInstance';

export const Paymentallocation = async (payload) => {
    const response = await axiosInstance.post('/portfolio/update-allocation', payload);
    return response.data;
};

export const MultibaggerAllocation = async (payload) => {
    const response = await axiosInstance.post('/wealth/update-allocation', payload);
    return response.data;
};

export const ContactUs = async (payload) => {
    const response = await axiosInstance.post('/contact-us', payload);
    return response.data;
};

export const UserPortfolio = async (payload) => {
    const selectedPortfolioId = localStorage.getItem("selectedPortfolio")
    const response = await axiosInstance.get(`/inv-portfolio/${selectedPortfolioId}/portfolio`);
    return response.data;
};